import { TranslationFunctionType } from '@/common/types';
import { boolean, object, string } from 'yup';

export const googleSSOSchema = (
  hasClientSecret: boolean,
  t: TranslationFunctionType,
) =>
  object({
    displayName: string().nullable(),
    clientId: string().when('isSSO', {
      is: true,
      then: (schema) => schema.required(t('error.requiredField')),
      otherwise: (schema) => schema.nullable(),
    }),
    clientSecret: hasClientSecret
      ? string().nullable()
      : string().when('isSSO', {
          is: true,
          then: (schema) => schema.required(t('error.requiredField')),
          otherwise: (schema) => schema.nullable(),
        }),
    isSSO: boolean(),
  });
